// extracted by mini-css-extract-plugin
export default {"main":"_6ae9d65447 _6abb9bce42","xmark":"_4299763cee","fl_img":"_4e3dba608c _9cb68176bf"};